export default "__VITE_ASSET__Cvu5mi7v__"